import { useState } from 'react'
import { useNavigate, useLocation, useOutletContext } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { nextPage } from 'components/RCPro/helpers/nav'
import CircleOk from 'components/assets/icons/CircleOk'
import Arrow from 'components/assets/icons/Arrow'
import Button from 'components/common/Button/Button'
import style from './Activity.module.scss'
import Activity from 'components/RCPro/components/form/Activity/Activity'
import { formParams } from 'constants/inputValidation'

const RCProActivity = () => {
  const navigate = useNavigate()
  const { state, pathname } = useLocation()
  const [ nextPageTransition ] = useOutletContext()
  const { activity, layout: { next } } = state.texts
  const [ selectedDomain, setSelectedDomain ] = useState(state.domain ? activity?.domains.findIndex( domain => domain.sector === state.domain ) : undefined)
  const [ activities, setActivities ] = useState(state.domain ? activity?.domains.find( domain => domain.sector === state.domain ).activities : [])

  // Initialize form
  const {
    register,
    formState: { errors, isValid },
    handleSubmit,
    setValue,
    trigger,
    watch
  } = useForm({
    ...formParams,
    values: {
      activity: state.activity,
      domain: state.domain
    },
  })

  const selectDomain = (index) => {
    const { activities, sector } = activity?.domains[index]
    setSelectedDomain(index)
    setValue('domain', sector)
    setValue('activity', '')
    setActivities(activities)
  }

  const onActivityChange = datas => {
    setValue('activity', datas)
    trigger()
  }

  const onSubmit = handleSubmit(async data => {
    nextPage({ pathname, state, navigate, data })
    nextPageTransition()
  })

  return (
    <>
      <h1>{activity.title} 🖋</h1>

      <p>{activity.legend}</p>
      <ul className={style.domains}>
        {activity.domains.map( (domain, index) => (
          <li
            key={`domain-${index}`} onClick={() => selectDomain(index)}>
            {selectedDomain === index 
              ? <CircleOk fill={'#0000C9'} />
              : <div dangerouslySetInnerHTML={{__html: domain.icon}}></div>
            }
            <span>{domain.sector}</span>
          </li>
        ))}
      </ul>

      <form onSubmit={onSubmit}>
        <Activity
          activities={activities}
          onChange={onActivityChange}
          value={watch('activity')}
        />

        <Button
          label={<>{next} <Arrow /></>}
          onClick={handleSubmit}
          disabled={!isValid}
          type="primary"
        />
      </form>
    </>
  )
}

export default RCProActivity